export default __webpack_public_path__ + "static/media/bell.4d5227c4.svg";